'use client';

import styled from 'styled-components';
import { device } from '@/components/Media';

const Root = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    padding: 24px 38px;
    background-color: #f8f9fa;
    position: relative;
    overflow-x: hidden;

    @media ${device.laptopS} {
      padding: 24px 12px;
    }
`;

const ContentWrapper = styled.div`
    width: 100%;
    z-index: 2;
    display: flex;
`;

export default function NewAuthLayout({ children }) {
    return (
        <Root>
            <ContentWrapper>
                {children}
            </ContentWrapper>
        </Root>
    );
}
